import { UsersShared } from './../@shared/users.shared.module';
import { RegisterWebUserRoutingModule } from './register-web-user-routing.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RegisterWebUserComponent } from './register-web-user.component';

@NgModule({
  imports: [CommonModule, RegisterWebUserRoutingModule, UsersShared],
  declarations: [RegisterWebUserComponent],
})
export class RegisterWebUserModule {}
